const blobAssetBaseUrl = (process.env.REACT_APP_ASSET_BASE_URL || '').trim().replace(/\/+$/, '');

export function assetUrl(path) {
    if (!path || typeof path !== 'string') return path;
    if (/^https?:\/\//i.test(path)) return path;

    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const encodedPath = encodeURI(
        blobAssetBaseUrl.endsWith('/assets') && normalizedPath.startsWith('/assets/')
            ? normalizedPath.replace(/^\/assets/, '')
            : normalizedPath
    );

    return blobAssetBaseUrl ? `${blobAssetBaseUrl}${encodedPath}` : encodedPath;
}
